import api from "@/api/api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "@/api/statusHTTP";

export const buscarSaidasPrimeiroSemestreProduto = async (params) => {
  const url = `compras/produtos/heranca/saidas-primeiro-semestre-produto`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.dados_grafico;
  }

  logout();
}
export const buscarMediasMensaisEProjecao = async (params) => {
  const url = `compras/produtos/heranca/medias-e-projecao`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.dados;
  }

  logout();
}

export const salvarHeranca = async (params) => {
  const url = 'compras/produtos/heranca';
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.CREATED) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}
